import { Create, SimpleForm, TextInput } from 'react-admin';

export const EventCreate = () => (
    <Create redirect="show">
        <SimpleForm>
            <TextInput source="name" required />
            {/* <TextInput source="type" /> */}
        </SimpleForm>
    </Create>
);